const select = {
  select:'Выбрать',
  placeholder:'Выбрать предмет',
};
export default select;
